<template>
<!--  <footer class="element-fade-in">-->
  <footer>
    <footer-first v-if="page != undefined && (page === 'NodeContentPage' || page === 'NodePage' || page ===
    'NodeKundenseite')"
                  :slogan="slogan" :links="links" :social="social"></footer-first>
    <footer-second :copyright="copyright" :meta_nav="meta_nav"></footer-second>
  </footer>
</template>
<script>

  export default {
    components: {
      'footer-first': () => import('./FooterFirst'),
      'footer-second': () => import('./FooterSecond'),
    },
    props: {
      page: {
        type: String,
        default: () => '',
      },
      slogan: {
        type: String,
        default: () => '',
      },
      links: {
        type: Array,
        default: () => [],
      },
      social: {
        type: Array,
        default: () => [],
      },
      copyright: {
        type: String,
        default: () => '',
      },
      meta_nav: {
        type: Array,
        default: () => [],
      },
    }
  }
</script>
<style scoped lang="scss">

</style>
